import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'foodAndShelterAdminSearchfilter'
})
export class FoodAndShelterAdminSearchfilterPipe implements PipeTransform {

  transform(items: any[], filter: string): any {

    if (!items || !filter) {
      return items;
    }
    items = items.filter(item => item.agencyName.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.service.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.agencyType.toLowerCase().indexOf(filter.toLowerCase()) !== -1 || item.countyName.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    return items;

  }
}
